import { lazy } from 'react';

const Home = lazy(() => import(/* webpackChunkName: "pages/home" */ './Home'));

export { Home };
